<template>
  <v-card>
    <v-card-text>
      <v-layout wrap :style="{ margin: '-8px' }">
        <v-flex xs12 class="pa-2">
          <label for="beaconId" class="caption">Beacon</label>
          <v-autocomplete
            id="beaconId"
            v-model="form.beacon_id_list"
            :items="beaconBranchOptions"
            outline
            single-line
            hide-details
            clearable
            chips
            deletable-chips
            multiple
          />
        </v-flex>
        <v-flex xs12 class="pa-2">
          <label for="beaconConversation" class="caption">{{ $t('beacon_conversation') }}</label>
          <v-text-field
            id="beaconConversation"
            v-model="form.beacon_conversation"
            outline
            single-line
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <label for="dateFrom" class="caption">{{ $t('start_date') }}</label>
          <DatepickerCustomDialog v-model="form.date_from">
            <template #default="{ computedDate }">
              <v-text-field
                id="dateFrom"
                :value="computedDate"
                readonly
                outline
                single-line
                hide-details
              />
            </template>
          </DatepickerCustomDialog>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <label for="dateTo" class="caption">{{ $t('end_date') }}</label>
          <DatepickerCustomDialog v-model="form.date_to">
            <template #default="{ computedDate }">
              <v-text-field
                id="dateTo"
                :value="computedDate"
                readonly
                outline
                single-line
                hide-details
              />
            </template>
          </DatepickerCustomDialog>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn @click="clear">{{ $t('Clear Search') }}</v-btn>
      <v-btn color="primary" @click="submit">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog'

const initialForm = {
  beacon_id_list: [],
  beacon_conversation: '',
  date_from: dayjs().format('YYYY-MM-DD'),
  date_to: dayjs().format('YYYY-MM-DD')
}

export default {
  components: {
    DatepickerCustomDialog
  },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        ...initialForm,
        ...this.value
      }
    }
  },
  computed: {
    beaconBranchOptions() {
      try {
        return this.$store.state.beaconMasterData.beaconBranch.map(({ beacon_id, name }) => ({
          value: beacon_id,
          text: `${beacon_id}: ${name}`
        }))
      } catch (error) {
        return []
      }
    }
  },
  methods: {
    submit() {
      this.form = {
        ...this.form,
        page: 1
      }

      this.$emit('input', this.form)
    },
    clear() {
      this.form = {
        ...this.form,
        ...initialForm,
        page: 1
      }

      this.$emit('input', this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/AdvancedSearch.vue